






























































import { Component, Vue, Prop } from 'vue-property-decorator'
import DistributorSelect from '@/components/distributor-select/index.vue'
import CustomDistributorApi from '@/api/distributor/customDistributor/index'
@Component({
  components: {
    DistributorSelect
  }
})
export default class CustomDistributor extends Vue {
  pager = {
    pageSize: 10,
    pageIndex: 1,
    total: 0
  }
  columns = [
    {
      title: '姓名',
      key: 'name'
    },
    {
      title: '直接分佣比例',
      key: 'direct',
      slot: 'direct'
    },
    {
      title: '间接分佣比例',
      key: 'indirect',
      slot: 'indirect'
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action'
    }
  ]
  data = []
  mounted() {
    this.loadData()
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData()
  }
  loadData() {
    CustomDistributorApi.getList(
      this.pager.pageSize,
      this.pager.pageIndex
    ).then(res => {
      this.pager.total = res.data.totalCount
      this.data = res.data.items
    })
  }
  remoteItem(id) {
    CustomDistributorApi.deleteItem([id]).then(res => {
      this.$Message.success('删除成功')
      this.loadData()
    })
  }
  distributorSelectChange(e) {
    console.log('e: ', e)
    if (e.length <= 0) {
      return
    }
    var input = e.map(t => {
      return {
        userId: t.id,
        name: t.name,
        direct: 0,
        indirect: 0
      }
    })
    CustomDistributorApi.createBatch(input).then(res => {
      this.$Message.success('添加成功')
      this.loadData()
    })
  }
  onChange(row, val) {
    CustomDistributorApi.update(row.id, {
      direct: row.direct,
      indirect: row.indirect
    }).then(res => {
      this.$Message.success('修改成功')
    })
  }
}
